/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import UserGuideApi from "~/features/userGuide/UserGuideApi";
import getComplianceStatus from "~/features/userGuide/utils/getComplianceStatus";
import reportError from "~/utils/reportError";

export const getComplianceStatusAsync = createAsyncThunk("userGuide/getComplianceStatus", async () => {
  try {
    const complianceStatusRes = await UserGuideApi.getComplianceStatus();

    return getComplianceStatus(complianceStatusRes.data.status);
  } catch (error) {
    reportError(error);
  }
});

export const getHasPaymethodAsync = createAsyncThunk("userGuide/getHasPaymethod", async () => {
  try {
    const hasPaymethodRes = await UserGuideApi.getHasPaymethod();

    return hasPaymethodRes.data.result;
  } catch (error) {
    reportError(error);
  }
});
